// extracted by mini-css-extract-plugin
module.exports = {"license":"yd44KD1ObuBlwVd2vFkQ"};